import React from 'react'
import CompanyLogo from './Assets/option-west-logo 07 .png'

import './Footer.css'

import { FaEnvelope } from 'react-icons/fa'
import { FaFacebookSquare } from 'react-icons/fa'


function Footer() {
    return (
        <div className="footerContainer">
            <div className='footerContents'>
                <div className='contact-info'>

                    <div className='iconWLink'>
                    <FaEnvelope id='phone'/>
                    <p>KarinVRealtor@gmail.com</p>
                    </div>
            
                    <div className='iconWLink'>
                        <FaFacebookSquare id='facebook'/>
                        <a href="facebook.com/californialuxuryliving" id=''>Facebook.com/CaliforniaLuxuryLiving</a>
                    </div>
                </div>
                
                <img src={CompanyLogo} alt="Company Logo" id='logo'></img>
            </div>
        </div>
    );
}

export default Footer;